import { render, staticRenderFns } from "./Form22CaseInformation.vue?vue&type=template&id=c110383c&scoped=true"
import script from "./Form22CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form22CaseInformation.vue?vue&type=script&lang=ts"
import style0 from "./Form22CaseInformation.vue?vue&type=style&index=0&id=c110383c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c110383c",
  null
  
)

export default component.exports